<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Once-Off Invoice Report</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="onceOffForm">
            <div class="row mt-3  d-flex justify-content-center align-items-center flex-wrap grid-margin">
               
                <div class="col-md-4">
                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                        <mat-label>Billing Period Month</mat-label>
                        <input readonly matInput  [matDatepicker]="startDate" id="startDate"
                            formControlName="startDate" autocomplete="off" placeholder="Month and Year"
                            class="col-12 custom-input-border" specialIsAlphaNumeric required (click)="OpenDatePicker()"
                            style="color:black;" [min]="minDate" [max]="maxDate">
                        <!-- (dateChange)="generateInvoice()" -->
                        <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                            <button mat-icon-button>
                                <mat-icon>event</mat-icon>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                </svg>
                            </button>
                        </mat-datepicker-toggle>
                        <mat-datepicker #startDate startView="multi-year"
                            (monthSelected)="setMonthAndYear($event, startDate)" panelClass="example-month-picker">
                        </mat-datepicker>
                    </mat-form-field>
                </div>
                <button class="btn btn-primary align-self-end mr-3" (click)="generateInvoice()">Generate Report
                </button>
                <!-- <button (click)="Reset()" class="btn btn-secondary align-self-end">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="Reset()"></app-button>

               
            </div>
        </form>
    </div>
</div>